var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79997 3.9998C4.79997 4.8485 5.13711 5.66243 5.73723 6.26255C6.33734 6.86266 7.15128 7.1998 7.99997 7.1998C8.84866 7.1998 9.66259 6.86266 10.2627 6.26255C10.8628 5.66243 11.2 4.8485 11.2 3.9998C11.2 3.15111 10.8628 2.33718 10.2627 1.73706C9.66259 1.13695 8.84866 0.799805 7.99997 0.799805C7.15128 0.799805 6.33734 1.13695 5.73723 1.73706C5.13711 2.33718 4.79997 3.15111 4.79997 3.9998Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19997 15.1999V13.5999C3.19997 12.7512 3.53711 11.9373 4.13722 11.3372C4.73734 10.737 5.55127 10.3999 6.39997 10.3999H9.59997C10.4487 10.3999 11.2626 10.737 11.8627 11.3372C12.4628 11.9373 12.8 12.7512 12.8 13.5999V15.1999",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspector);
export default __webpack_public_path__ + "static/media/inspector.bcb1521fce273cdf9f922ae45c611ea3.svg";
export { ForwardRef as ReactComponent };